export const getXYChartKeyOptions = () => ({
  solarGenerated: {
    filled: false,
    negative: false,
    stacked: false,
    forceLine: true,
    opacity: 0.6,
    zIndex: -1,
  },
  consumedEnergy: {
    filled: true,
    negative: false,
    stacked: true,
    zIndex: 2,
    barZIndex: 2,
  },
  generatedEnergy: {
    filled: true,
    negative: false,
    stacked: true,
    zIndex: 2,
    barZIndex: 2,
  },
  netConsumed: {
    filled: false,
    negative: false,
    stacked: false,
    forceLine: true,
    zIndex: 3,
    barZIndex: 3,
  },
  solarFeedIn: {
    filled: true,
    negative: true,
    stacked: true,
    zIndex: 0,
  },
  solarReturned: {
    filled: true,
    negative: true,
    stacked: true,
    zIndex: 0,
  },
  gridConsumed: {
    filled: true,
    negative: false,
    stacked: true,
    zIndex: 2,
    barZIndex: 2,
  },
  solarConsumed: {
    filled: true,
    negative: false,
    stacked: true,
    zIndex: 3,
    barZIndex: 1,
  },
});

export const generateCompareAppKeyOptions = (objects) => {
  const output = {};
  objects.forEach((object) => {
    output[`solar_${object.id}`] = {
      negative: false,
      filled: false,
      stacked: false,
      name: object.name,
      color: object.color,
      forceLine: true,
      zIndex: 1,
    };
  });
  return output;
};

// generated generic keys for use in namemaps and data aggregation
export const getGenericKeys = (length) =>
  length
    ? Array(length)
        .fill(0)
        .map((_, index) => `key-${index}`)
    : null;

// export const getSubMeterNameMaps = (subMeters, genericKeys) => subMeters.map((subMeter, index) => {[genericKeys[index]: })
export const getSubMeterNameMaps = (subMeters, genericKeys) =>
  subMeters && genericKeys
    ? subMeters.reduce((acc, subMeter, index) => {
        acc[genericKeys[index]] = subMeter.name;
        return acc;
      }, {})
    : null;



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/Charts/getKeyOptions.js